export const importFileModalReducerKey = 'importFileModalReducerKey';
export const importFileModalSetIsLoadingReducerType = 'importFileModalSetIsLoadingReducerType';
export const importFileModalSetUploadedFileReducerType = 'importFileModalSetUploadedFileReducerType';
export const importFileModalSetIsClosedReducerType = 'importFileModalSetIsClosedReducerType';

export const typeOfImportFileModal = 'typeOfImportFileModal';
